/**
 * Reference Communication Template types
 */

export const COMMUNICATION_TYPE_IDS = {
  SMS: 352,
  EMAIL: 353,
  NOTIFICATION: 388,
} as const;

export const COMMUNICATION_TYPE_VALUES = {
  SMS: "SMS",
  EMAIL: "EMAIL",
  NOTIFICATION: "NOTIFICATION",
} as const;

export type CommunicationTypeValues =
  (typeof COMMUNICATION_TYPE_VALUES)[keyof typeof COMMUNICATION_TYPE_VALUES];

export type CommunicationTypeId =
  (typeof COMMUNICATION_TYPE_IDS)[keyof typeof COMMUNICATION_TYPE_IDS];

/**
 * What a template is for, as `GET /api/refCommunicationTemplates/type-codes`.
 * Only the templates of a type can be used by its feature: a follow-up uses
 * `FOLLOW_UP`, a product reminder `PRODUCT_REMINDER`, and every other send
 * `GENERIC`.
 */
export const COMMUNICATION_TEMPLATE_TYPE_CODES = {
  GENERIC: "GENERIC",
  FOLLOW_UP: "FOLLOW_UP",
  PRODUCT_REMINDER: "PRODUCT_REMINDER",
} as const;

export type CommunicationTemplateTypeCode =
  (typeof COMMUNICATION_TEMPLATE_TYPE_CODES)[keyof typeof COMMUNICATION_TEMPLATE_TYPE_CODES];

export interface RefCommunicationTemplate {
  id: number;
  communicationTypeId?: CommunicationTypeId;
  name: string;
  subject: string;
  body: string;
  isExternal?: boolean;
  externalTemplateId?: string;
  createdOn?: string;
  createdBy?: string;
  updatedOn?: string;
  updatedBy?: string;
}

export interface RefCommunicationTemplateView {
  id: number;
  name: string;
  subject: string;
  isActive: boolean;
  body: string;
  typeCode?: CommunicationTemplateTypeCode;
  isExternal?: boolean;
  communicationType?: {
    id: number;
    value: CommunicationTypeValues;
  };
  placeholderCodes?: string[];
}

export interface RefCommunicationTemplateListParams {
  page?: number;
  size?: number;
  typeCode?: CommunicationTemplateTypeCode;
  isExternal?: boolean;
  communicationTypeId?: number;
  signal?: AbortSignal;
}

export interface RefCommunicationTemplateCreateData {
  communicationTypeId?: CommunicationTypeId;
  name: string;
  subject: string;
  body: string;
  isExternal?: boolean;
  externalTemplateId?: string;
  /** What the model is for. The API defaults it to `GENERIC`. */
  typeCode?: CommunicationTemplateTypeCode;
}

export interface RefCommunicationTemplatePageResponse {
  content: RefCommunicationTemplateView[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}
